import * as React from "react";

import Button from "@mui/joy/Button";
import OpenInNew from "@mui/icons-material/OpenInNew";

export default function Introduction(props) {
  return (
    <div className="centerButton">
      <Button
        className="buttonLink"
        component="a"
        href={props.link}
        startDecorator={<OpenInNew />}
        variant="outlined"
        color="neutral"
      >
        查看更多
      </Button>
    </div>
  );
}
